/*
 * Module for the Rollover Account Information Step of the MemberDirect DROP Distribution Election wizard
*/
rs.module("ui/content/communications/onlineforms/rolloveraccountinformation",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "controls/navigation/wizard"
    ],

    function (selectHelper, eventBanner, wizard) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var addressSection = stepContainer.js(jsSelectors.addressSection);
            var form = stepContainer.closest("form");
            var finInstitutionName = stepContainer.js(jsSelectors.finInstitutionName);
            var accountNumberTextBox = stepContainer.js(jsSelectors.accountNumberTextBox);
            var address1 = stepContainer.js(jsSelectors.address1); 
            var address2 = stepContainer.js(jsSelectors.address2);
            var city = stepContainer.js(jsSelectors.city);
            var state = stepContainer.js(jsSelectors.state);
            var zipCode = stepContainer.js(jsSelectors.zipCode); 

            if (finInstitutionName != null && finInstitutionName.val() !== ""
                && accountNumberTextBox != null && accountNumberTextBox.val() !== "") {
                // Show the address section on page load because we have a bank info entered
                hideShowAddressSection(false);
            }

            // enable/disable form controls based on the fin institution name
            finInstitutionName.change(function () {
                if (finInstitutionName != null && finInstitutionName.val() !== "") {
                    enableFormControls(true);
                }
                else {
                    enableFormControls(false);
                }
            });

            // enable/disable form controls depending on the validity of the aba number
            function enableFormControls(enable) {
                accountNumberTextBox.prop("disabled", !enable);
                hideShowAddressSection(!enable);
            }

            // Hide or show address section
            function hideShowAddressSection(hide) {
                if (hide) {
                    // Close section quickly
                    addressSection.stop(true, true).slideUp(150);
                    clearAddressFields();
                }
                else {
                    // Slide open section
                    addressSection.stop(true, true).slideDown(150);
                }
            }

            // Clear all address data and errors
            function clearAddressFields() {
                address1.val('').clearErrors();
                address2.val('').clearErrors();
                city.val('').clearErrors();
                state.val('').trigger('change').clearErrors();
                zipCode.val('').clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);